module.exports = __webpack_public_path__ + "static/media/hero.2ad881ba.png";